/** GraphQL Mutation that updates a customer address. */
export default `
  mutation updateCustomerAddress($id: Int!, $input: CustomerAddressInput) {
    updateCustomerAddress(id: $id, input: $input) {
      id
      city
      company
      custom_attributesV2(attributeCodes: [
        "company_email", "invoice_email"
      ]){
        code
        ... on AttributeValue {
          value
        }
      }
      country_code
      default_billing
      default_shipping
      extension_attributes {
        attribute_code
        value
      }
      fax
      firstname
      id
      lastname
      middlename
      postcode
      prefix
      region {
        region
        region_code
        region_id
      }
      street
      suffix
      telephone
      vat_id
    }
  }
`;
